import * as Linking from 'expo-linking';
import { useRouter } from 'expo-router';
import { useState } from 'react';
import { View } from 'react-native';

import { Bounded } from '@/components/ui/Bounded';
import { Button } from '@/components/ui/Button';
import { Form } from '@/components/ui/Form';
import { NavBar } from '@/components/ui/NavBar';
import { Screen } from '@/components/ui/Screen';
import { StatusBanner } from '@/components/ui/StatusBanner';
import { Text } from '@/components/ui/Text';
import { TextField } from '@/components/ui/TextField';
import { useGoBack } from '@/lib/navigation';
import { supabase } from '@/lib/supabase';
import { useAsyncAction } from '@/lib/useAsyncAction';

export default function ResetRequestScreen() {
  const router = useRouter();
  const goBack = useGoBack('/sign-in');
  const [email, setEmail] = useState('');
  const { busy, error, setError, run } = useAsyncAction();

  async function submit() {
    if (!email.trim()) {
      setError('Enter your email.');
      return;
    }
    await run(async () => {
      const redirectTo = Linking.createURL('reset/new-password');
      const { error: e } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo,
      });
      if (e) throw e;
      router.push(`/reset/check-email?email=${encodeURIComponent(email.trim())}`);
    });
  }

  return (
    <Screen edges={['top']}>
      <NavBar onBack={goBack} title="Password reset" />
      <Bounded className="px-6 pt-4">
        <Form onSubmit={submit} className="gap-5">
          <View className="gap-1">
            <Text variant="title">Reset your password</Text>
            <Text variant="subtitle">
              Enter the email for your account and we&apos;ll send a secure link to set a
              new one.
            </Text>
          </View>
          <TextField
            label="Email"
            value={email}
            onChangeText={setEmail}
            placeholder="you@example.com"
            autoCapitalize="none"
            autoComplete="email"
            textContentType="username"
            importantForAutofill="yes"
            keyboardType="email-address"
            inputMode="email"
          />
          {error ? (
            <Text variant="caption" className="text-alert">
              {error}
            </Text>
          ) : null}
          <Button block submit label="Send reset link" busy={busy} />
          <StatusBanner
            variant="positive"
            title="Secure link via Supabase"
            subtitle="The link expires in 60 minutes."
          />
        </Form>
      </Bounded>
    </Screen>
  );
}
